import React from 'react'

import { Form, Input, Button, Row, Col, Modal, notification } from "antd";
import { createDiscountCode } from '../../../api/discount.service';

export default function AddDiscountCodeModal({ isModalOpen, setIsModalOpen, handleOk, handleCancel, fetchVehicles }) {
    const onFinish = async (values) => {
        try {
            await createDiscountCode(values);
            notification.success({ message: "Discount Code added" });
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add Discount Code" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{
                    discountCode: "",
                    discountPercent: 0,
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Discount Code" name="discountCode" rules={[{ required: true, message: "Please enter discount code" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Discount Percent" name="discountPercent" rules={[{ required: true, message: "Please enter discount percentage" }]}>
                                <Input type='number' min={0} max={100} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};